/* Uorja motion: scroll reveal, reading progress, header state, hero drift.
   Everything is skipped when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = document.querySelector('.page-wrapper');
  var scrollHost = scroller && scroller.scrollHeight > scroller.clientHeight + 10 ? scroller : window;

  function scrollTop() {
    return scrollHost === window ? window.scrollY : scrollHost.scrollTop;
  }
  function scrollMax() {
    return scrollHost === window
      ? document.documentElement.scrollHeight - window.innerHeight
      : scrollHost.scrollHeight - scrollHost.clientHeight;
  }

  /* ---- reveal on scroll ---- */
  function markReveals(root) {
    var targets = root.querySelectorAll(
      [
        'product-card',
        '.collection-card__inner',
        '.section-resource-list__header',
        '.uorja-tabs__header',
        '.uorja-tabs__nav',
        '.uorja-offer__inner',
        '.size-filter',
        '.marquee',
        '.shopify-section-group-footer-group .group-block',
        '.shopify-section-group-footer-group .menu',
        '.product-information .product-details > *',
        '.section > .group-block-content > .text-block',
        '[data-uorja-reveal]',
        '.main-page .group-block > .group-block-content > .text-block'
      ].join(',')
    );
    var byParent = new Map();
    targets.forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      if (el.hasAttribute('data-uorja-reveal') && el.getAttribute('data-uorja-reveal') === 'in') return;
      el.setAttribute('data-reveal', '');
      var parent = el.parentElement;
      var n = byParent.get(parent) || 0;
      byParent.set(parent, n + 1);
      el.style.setProperty('--reveal-delay', Math.min(n, 7) * 70 + 'ms');
    });
  }

  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('uorja-motion');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.setAttribute('data-reveal', 'in');
            if (e.target.hasAttribute('data-uorja-reveal')) e.target.setAttribute('data-uorja-reveal', 'in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    var observeAll = function () {
      markReveals(document);
      document.querySelectorAll('[data-reveal=""]').forEach(function (el) { io.observe(el); });
    };
    observeAll();
    /* Sections re-render in the editor and on filter/pagination changes. */
    new MutationObserver(function () { observeAll(); }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', observeAll);
  }

  /* ---- reading progress + header shadow ---- */
  var bar = document.createElement('div');
  bar.className = 'uorja-progress';
  document.body.appendChild(bar);
  var header = document.getElementById('header-component');
  var hero = document.querySelector('[id$="__slideshow_hero"] slideshow-slides');
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var top = scrollTop();
      var max = scrollMax();
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(top / max, 1) : 0) + ')';
      if (header) header.classList.toggle('uorja-scrolled', top > 24);
      ticking = false;
    });
  }
  (scrollHost === window ? window : scrollHost).addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
